import {IApp} from "@/interfaces/app.interface";
import {Vue} from "vue-property-decorator";
import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";

export function ThemeColorDetect() {
  const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
  let isDarkTheme = darkModeQuery.matches;
  let themeName = isDarkTheme ? IApp.ThemeName.Dark : IApp.ThemeName.Light;

  let cookieTheme = Vue.cookie.get(IApp.GlobalCookie.AppThemeName);
  if (cookieTheme && cookieBannerHelper.cookieConfig.optional) themeName = cookieTheme as IApp.ThemeName;

  document.documentElement.setAttribute('data-theme', themeName);
}
